import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { articlePath, catName } from "@/lib/api";
import { BrandImg, Meta, NewsRow } from "./NewsCard";

export const SectionTitle = ({ children, to, testid }) => (
  <div className="mb-5 flex items-end justify-between border-b-2 border-foreground pb-2">
    <h2 className="font-serif-display text-2xl font-black uppercase tracking-tight text-primary">{children}</h2>
    {to && <Link to={to} data-testid={testid} className="flex items-center gap-1 text-xs font-bold uppercase tracking-wider hover:text-primary">Ver mais <ArrowRight size={14} /></Link>}
  </div>
);

export function CategorySection({ slug, items }) {
  const [main, ...rest] = items;
  if (!main) return null;
  return (
    <section data-testid={`home-section-${slug}`}>
      <SectionTitle to={`/categoria/${slug}`} testid={`section-more-${slug}`}>{catName(slug)}</SectionTitle>
      <div className="grid gap-6 md:grid-cols-2">
        <Link to={articlePath(main)} className="group block">
          <div className="aspect-video overflow-hidden rounded-lg bg-muted"><BrandImg a={main} className="img-zoom" /></div>
          <div className="mt-3"><Meta a={main} /></div>
          <h3 className="mt-1 font-serif-display text-xl font-bold leading-snug group-hover:text-primary line-clamp-3">{main.title}</h3>
        </Link>
        <div className="divide-y">{rest.slice(0, 4).map((a) => <NewsRow key={a.id} a={a} />)}</div>
      </div>
    </section>
  );
}
